import { useQuery } from '@apollo/client';

import PROGRAM_DETAILS from './graphql';
import { ProgramGenderEnum } from '../../../../shared/gender-enum';

const useProgramDetails = (programId?: string) => {
  const { data, loading, error } = useQuery(PROGRAM_DETAILS, {
    skip: !programId,
    variables: { id: programId! },
  });

  const { league } = data ?? {};

  const gender = league?.gender || ProgramGenderEnum.COED;
  const programImage = league?.header || '';
  const formatType = league?.formatType || 'N/A';
  const displayName = league?.displayName || '';
  const programType = league?.programType || '';
  const banner_text = league?.banner_text || '';
  const price_phase = league?.price_phase || '';
  const hasDivisions = league?.hasDivisions || false;
  const divisionDescriptions = league?.divisionDescriptions || [];
  const features = league?.details?.features || [];
  const num_weeks_estimate = league?.num_weeks_estimate || 0;
  const start_date = league?.start_date || '';
  const end_time_estimate = league?.end_time_estimate || '';
  const start_time_estimate = league?.start_time_estimate || '';
  const isVoloPassExclusive = league?.is_volo_pass_exclusive ?? false;
  const isPremier = league?.is_premier ?? false;

  const venue = league?.venue;
  const registration = league?.registration || {};

  return {
    loading,
    error,
    venue,
    registration,
    gender,
    features,
    formatType,
    programType,
    banner_text,
    displayName,
    price_phase,
    programImage,
    hasDivisions,
    divisionDescriptions,
    num_weeks_estimate,
    start_date,
    end_time_estimate,
    start_time_estimate,
    isVoloPassExclusive,
    isPremier,
  };
};

export default useProgramDetails;
